module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBoldItalic.edbbf533.woff";